<template>
  <div class="projects-wrapper">
    <div
      class="projects"
      :class="{ 'projects-mobile-hidden': this.$route.name !== 'companies' }"
    >
      <div class="projects-header">
        <h2 class="desktop">Отдели</h2>
      </div>
      <div
        class="companies-container"
        :class="{ 'no-overflow': this.$route.name === 'companies' }"
      >
        <CompaniesTree :showActiveProjects="showActiveProjects" />

        <a
          @click="addNewCompany($event)"
          href="/companies/new"
          class="new-company-button"
        >
          <span class="mck">a</span>
          <span>Добави нов отдел</span>
        </a>
      </div>
      <!-- BUTTON NEW COMPANY FOR MOBILE -->
      <footer class="modal-footer mobile">
        <div
          class="new-content-data-item-toggle-circle mobile"
          v-if="this.$route.name === 'companies'"
          @click="newCompany()"
        >
          <span class="mck">L</span>
        </div>
      </footer>
    </div>
    <transition name="slideFromRight">
      <div
        class="companies-right"
        v-if="
          this.$route.name !== 'newProject' && this.$route.name !== 'getProject'
        "
      >
        <header>
          <!-- ACTIVE/INACTIVE SWITCH -->
          <div class="switch-wrapper" v-if="this.$route.name === 'companies'">
            <label
              class="switch-label"
              :class="{ 'switch-label-active': !showActiveProjects }"
              @click="showActiveProjects = false"
              >Неактивни</label
            >
            <div class="switch-container">
              <label class="switch">
                <input type="checkbox" v-model="showActiveProjects" />
                <span class="slider"></span>
              </label>
            </div>
            <label
              class="switch-label"
              :class="{ 'switch-label-active': showActiveProjects }"
              @click="showActiveProjects = true"
              >Активни</label
            >
          </div>
        </header>
        <main>
          <img src="../assets/img/helpOtdel.svg" alt="Структура на отдел" />
        </main>
      </div>
    </transition>
    <!-- COMPANY DETAILS SLIDE -->
    <transition name="slideFromRight">
      <Company
        ref="companyRef"
        v-if="
          this.$route.name === 'newProject' || this.$route.name === 'getProject'
        "
      />
    </transition>
  </div>
</template>

<script>
import Company from "./Company";
import CompaniesTree from "./shared/CompaniesTree.vue";
import contrast from "./mixins/contrast";
import { getAccess } from "./mixins/getAccess";
export default {
  mixins: [contrast],
  components: {
    Company: Company,
    CompaniesTree,
  },
  data() {
    return {
      showActiveProjects: true,
    };
  },
  methods: {
    addNewCompany(e) {
      if (!getAccess("companies_projects", "companies", true)) {
        e.preventDefault();
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (
      this.$route.name === "newProject" ||
      this.$route.name === "getProject"
    ) {
      this.$refs.companyRef.checkForChanges(next);
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.$route.name === "newProject" ||
      this.$route.name === "getProject"
    ) {
      this.$refs.companyRef.checkForChanges(next);
    } else {
      next();
    }
  },
};
</script>

<style scoped>
.projects-wrapper {
  display: flex;
}
.projects {
  padding: 10px 20px;
  width: 100%;
  transition: all 0.3s;
}
.projects-wrapper .projects {
  padding-right: 0;
  width: 25%;
}
.projects-header {
  align-items: center;
  display: flex;
  height: 30px;
  justify-content: space-between;
  margin-bottom: 10px;
}
.companies-container {
  overflow: auto;
  max-height: 100vh;
}
.no-overflow {
  overflow: unset;
  max-height: none;
}
.switch-wrapper {
  align-items: center;
  display: flex;
}
.switch {
  margin: 0 8px;
}
.switch-label {
  cursor: pointer;
  font-weight: 700;
  opacity: 0.4;
}
.switch-label-active {
  opacity: 1;
}

.new-company-button {
  align-items: center;
  background-color: #e65100;
  border-radius: 4px;
  color: #fff;
  display: flex;
  font-size: 13px;
  height: 30px;
  justify-content: center;
  margin-top: 10px;
  padding: 0 10px 0 40px;
  position: relative;
  width: 100%;
}
.new-company-button .mck {
  font-size: 18px;
  justify-self: flex-start;
  left: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.companies-right {
  padding: 10px 20px;
  width: 75%;
}
.companies-right header {
  display: flex;
  height: 30px;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.companies-right main {
  align-items: center;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  height: calc(100vh - 110px);
}
.companies-right main img {
  width: 43%;
}

.desktop {
  display: flex;
}
.mobile {
  display: none;
}
@media screen and (max-width: 1000px) {
  .desktop,
  .projects-mobile-hidden {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .projects {
    padding: 10px 15px;
    width: 100%;
  }
  .projects-header {
    justify-content: center;
    width: 100%;
  }
  .projects-wrapper.projects-wrapper-side-panel {
    justify-content: center;
  }
  .company-toggle {
    height: 65px;
    width: 100%;
  }
  .project-toggle-active,
  .new-btn-mini-toggle-active {
    height: 40px;
    width: 100%;
  }
  .new-content-data-item-toggle-circle {
    font-size: 20px;
    height: 50px;
    width: 50px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .modal-footer {
    background-color: #f0f0f7;
    height: 75px;
    padding: 0px;
  }
}
</style>
